<p-card>
  <ng-template #title>{{ device().name || 'N/A' }}</ng-template>
  <ng-template #subtitle>{{ ('devices.types.' + device().deviceType | translate) || device().deviceType || ('cards.device.subtitle' | translate) }}</ng-template>

  @if (device().loramac) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-qrcode"></i></div>
      <div class="item-text">
        <div class="item-title">{{ device().loramac }}</div>
        <div class="item-line">ID</div>
      </div>
    </div>
  }

  @if (device().project) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-folder-open"></i></div>
      <div class="item-text">
        <div class="item-title">{{ device().project?.name || 'N/A' }}</div>
        <div class="item-line">{{ "cards.device.project" | translate }}</div>
      </div>
    </div>
  }

  @if (device().available !== undefined && device().available !== null) {
    <div class="card-list-item">
      <div class="card-list-item-icon">
        <i class="fa-solid" [ngClass]="{'fa-lock': !device().available, 'fa-lock-open': device().available}"></i>
      </div>
      <div class="item-text">
        <div class="item-title">
          @if (!device().available) {
            {{ "cards.device.measurement" | translate }} {{ device().measurement ? device().measurement?.name : '-' }}
          } @else {
            {{ "cards.device.available" | translate }}
          }
        </div>
        <div class="item-line">
          {{ (!device().available ? "cards.device.used" : "cards.device.available") | translate }}
        </div>
      </div>
    </div>
  }

  @if (device().battery !== undefined && device().battery !== null) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i [class]="'fa-solid ' + getBattery(device().battery ?? 0)[1]"></i></div>
      <div class="item-text">
        <div class="item-title">{{ getBattery(device().battery ?? 0)[2] }}</div>
        <div class="item-line">{{ "cards.device.battery" | translate }}</div>
      </div>
    </div>
  }

  @if (device().transmission; as transmission) {
    @if (transmission.length > 0) {
      <div class="card-list-item">
        <div class="card-list-item-icon">
          <i [class]="'fa-solid ' + getTransmissionDetails(transmission[transmission.length - 1])[1]"></i>
        </div>
        <div class="item-text">
          <div class="item-title">{{ getTransmissionDetails(transmission[transmission.length - 1])[2] }}</div>
          <div class="item-line">{{ "cards.device.signal" | translate }}</div>
        </div>
      </div>
    }
  }

  <p-divider></p-divider>

  @if (showNavigation() && resolvedProjectId()) {
    <ng-template #footer>
      <div class="flex gap-4">
        <button pButton routerLink="/projects/{{ resolvedProjectId() }}/monitoring/devices/{{ device()._id }}">{{ "button.details" | translate }}</button>
        @if (!device().available && device().measurement?.stage) {
          <button pButton severity="secondary"
            routerLink="/projects/{{ resolvedProjectId() }}/monitoring/measurement/{{ device().measurement._id }}">
            {{ "cards.device.view_measurement" | translate }}
          </button>
        }
      </div>
    </ng-template>
  }
</p-card>
